<template>
    <div
        v-if="slides"
        id="rotator"
    >
        <ul
            id="cycle-livestream"
            :data-id="slug"
            data-cycle-fx="fade"
            data-cycle-speed="700"
            data-cycle-swipe="true"
            data-cycle-log="false"
            data-cycle-pager=".pager-wrap"
            data-cycle-pager-template=""
            data-cycle-slides=".slide"
            data-cycle-next="#next"
            data-cycle-prev="#prev"
            data-cycle-auto-height="calc"
            :data-cycle-timeout="transitionms"
        >
            <template v-for="slide in slides">
                <!-- Display image rotator slides -->
                <li
                    v-if="!slide.ifvideo"
                    :class="'slide image-slide pos-' + slide.position"
                    :data-position="slide.position"
                >
                    <a
                        :href="slide.url"
                        :target="slide.ifurlnewwindow ? '_blank' : ''"
                    >
                        <img :src="slide.imageurl" />
                    </a>
                </li>

                <!-- Display video rotator slides -->
                <li
                    v-else
                    :class="'slide pos-' + slide.position"
                    :data-position="slide.position"
                >
                    <a
                        @click="openVideoSlide(slide)"
                        class='video-slide'
                        href='#'
                    >
                        <img :src="slide.videopreviewimageurl" />

                        <div style='display:none'>
                            <div :id="'video-' + slide.position">
                                <sc-video
                                    v-if="slide.videourl"
                                    :src="slide.videourl"
                                ></sc-video>
                            </div>
                        </div>
                    </a>
                </li>
            </template>
        </ul>

        <div class='pager'>
            <div
                id='prev'
                class='chevron-arrow pager-button'
            ></div>
            <div class='pager-wrap'>
                <span
                    v-for="slide in slides"
                    class="pager-circle pager-button"
                ></span>
            </div>
            <div
                id='next'
                class='chevron-arrow pager-button'
            ></div>
        </div>
    </div>
</template>

<script>
import JQuery from 'jquery'
let $ = JQuery
window.jQuery = JQuery
require('jquery-colorbox')
require('cycle2/src/jquery.cycle2')
require('jquery.cycle2.swipe')

export default {
    props: {
        rotatorData: Object
    },
    data() {
        return {
            slides: undefined,
            slug: undefined,
            transitionms: undefined
        }
    },
    mounted() {
        this.initRotator();
    },
    methods: {
        /**
         * Setup and start the rotator
         */
        initRotator() {
            this.slides = this.rotatorData.slide_show;
            this.slug = this.rotatorData.before_show.slug;
            this.transitionms = this.rotatorData.before_show.transitionms;

            this.$nextTick(function() {
                $('#cycle-livestream').cycle();
            });
        },

        /**
         * Open a video slide in a colorbox modal or new page when clicked
         *
         * @param {Object} slide - the video slide to play
         */
        openVideoSlide(slide) {
            // If this is an embedded video
            if (slide.ifvideoembed) {
                this.showVideo(
                    slide.videoembedurl,
                    slide.videoembedurl,
                    true
                );
            } else if (slide.ifvideohosted) {
                this.showVideo(
                    slide.videourl,
                    '#video-' + slide.position,
                    false
                );
            }
        },

        /**
         * Open the video in a colorbox or new page
         *
         * @param {String} mobileURL - the url that will be opened on mobile devices
         * @param {String} colorboxURL - the id / href the colorbox should display
         * @param {Boolean} iframe - if the colorbox should open an iframe
         */
        showVideo(mobileURL, colorboxURL, iframe) {
            if (this.mobileDetect()) {
                window.open(mobileURL);
            } else {
                $.colorbox({
                    scrolling: false,
                    inline: !iframe,
                    iframe: iframe,
                    href: colorboxURL,
                    innerWidth: 800,
                    innerHeight: 448,
                    maxWidth: '95%',
                    maxHeight: '95%',
                    onOpen: function(){
                        $('.cycle-slideshow').cycle('pause');
                    },
                    onCleanup: function(){
                        $('.cycle-slideshow').cycle('resume');

                        // Force all videos to stop playing
                        document.getElementById('cboxLoadedContent').innerHTML = '';
                    }
                });
            }
        },

        /**
         * Determine if the user is on a mobile device
         *
         * @returns {boolean}
         */
        mobileDetect() {
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        }
    }
}
</script>

<style lang="scss" scoped>
    .chevron-arrow {
        border-bottom: 4px solid var(--user-alternate-color) !important;
        border-right: 4px solid var(--user-alternate-color) !important;
        display: inline-block;
        height: 12px;
        position: relative;
        width: 12px;
    }

    #rotator {
        position: relative;
    }

    #rotator ul {
        list-style: none;
        margin: 0;
        overflow: hidden;

        // NB: Using vw instead of padding-top due to a bug in Chrome
        //     The padding-top method follows video-js' vjs-fluid pattern
        //     I have filed a bug with video-js and we should update this when they respond
        //     https://github.com/videojs/video.js/issues/7018
        //padding: 56.25% 0 0 0;
        height: 54.55vw; // Using 54.55 instead of 56.25 because vw doesn't account for scroll bars
    }

    #rotator .slide,
    #rotator img {
        height: auto;
        width: 100%;
    }

    #rotator .pager {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 20px;
        text-align: center;
        z-index: 100;
    }
    #rotator .pager .pager-wrap {
        display: inline;
    }

    #rotator .pager .pager-circle {
        background-color: var(--user-alternate-color) !important;
        -webkit-border-radius: 14px;
        -moz-border-radius: 14px;
        -ms-border-radius: 14px;
        -o-border-radius: 14px;
        border-radius: 14px;
        height: 14px;
        margin: 0 6px;
        width: 14px;
    }

    #rotator .pager .pager-button {
        -webkit-box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.7);
        -moz-box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.7);
        box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.7);
        cursor: pointer;
        display: inline-block;
        opacity: 0.5;
        -webkit-transition: background-color 0.15s ease-in-out;
        -moz-transition: background-color 0.15s ease-in-out;
        -o-transition: background-color 0.15s ease-in-out;
        transition: background-color 0.15s ease-in-out;
    }

    #rotator .pager .pager-button:hover,
    #rotator .pager .pager-circle.cycle-pager-active {
        opacity: 1;
    }

    #rotator .pager #prev,
    #rotator .pager #next {
        border-color: #fff;
    }

    #rotator .pager #prev:hover,
    #rotator .pager #next:hover {
        border-color: #fff;
        opacity: 1;
    }

    #rotator .pager #next {
        transform: rotate(-45deg);
    }

    #rotator .pager #prev {
        transform: rotate(-225deg);
    }
</style>
